// components/GridControls.jsx
import Tippy from '@tippyjs/react';
import { Columns3, Grid, Grid2X2, LayoutDashboard } from 'lucide-react';
import 'tippy.js/dist/tippy.css';

export default function GridControls({ gridSize, setGridSize, windowWidth }) {
  return (
    <>
      <style>{`
        @media (min-width: 1200px) {
          .col-xl-custom-5 {
            flex: 0 0 20%;
            max-width: 20%;
          }
        }
        @media (min-width: 1600px) {
          .col-xxl-custom-6 {
            flex: 0 0 16.6667%;
            max-width: 16.6667%;
          }
        }
        .grid-toggle-group {
          display: inline-flex;
          gap: 1rem;
          border-bottom: 1px solid purple;
          padding-bottom: 2px;
        }
        .grid-toggle-btn {
          padding:5px;
          border:none;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease-in-out;
          background-color: transparent;
        }
        .grid-toggle-btn:hover {
          color: #791989;
        }
        .grid-toggle-btn.active {
          color: purple !important;
          border-color: #4f46e5;
        }
      `}</style>

      <div className="row justify-content-end mb-3">
        <div className="col-auto">
          <div
            className="grid-toggle-group d-none d-lg-inline-flex"
            role="group"
          >
            {windowWidth >= 1200 && (
              <>
                <Tippy content="3 prod/row" placement="bottom">
                  <button
                    className={`grid-toggle-btn ${
                      gridSize === 3 ? 'active' : ''
                    }`}
                    onClick={() => setGridSize(3)}
                  >
                    <Columns3 size={18} />
                  </button>
                </Tippy>

                <Tippy content="4 prod/row" placement="bottom">
                  <button
                    className={`grid-toggle-btn ${
                      gridSize === 4 ? 'active' : ''
                    }`}
                    onClick={() => setGridSize(4)}
                  >
                    <Grid2X2 size={18} />
                  </button>
                </Tippy>

                {windowWidth >= 1390 && (
                  <Tippy content="5 prod/row" placement="bottom">
                    <button
                      className={`grid-toggle-btn ${
                        gridSize === 5 ? 'active' : ''
                      }`}
                      onClick={() => setGridSize(5)}
                    >
                      <LayoutDashboard size={18} />
                    </button>
                  </Tippy>
                )}
                {windowWidth >= 1600 && (
                  <Tippy content="6 prod/row" placement="bottom">
                    <button
                      className={`grid-toggle-btn ${
                        gridSize === 6 ? 'active' : ''
                      }`}
                      onClick={() => setGridSize(6)}
                    >
                      <Grid size={18} />
                    </button>
                  </Tippy>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
